(function ($) {
 "use strict";
  
  	jQuery(document).ready(function(){
  
	/*--------------------------
	 telefonos-accesorios-curosel
	----------------------------*/
	$(".tel-carousel").owlCarousel({
		autoPlay: false, 
		slideSpeed:2000,
		items : 4,
		pagination:true,
		navigation:true,
		navigationText:["<i class='dp- dp-left-arrow'></i>","<i class='dp- dp-right-arrow'></i>"],
		rewindNav : false,
		lazyLoad : true
	});
      
	/*--------------------------
	 carro-accesorios-curosel
	----------------------------*/
	$(".autos-carousel").owlCarousel({
		autoPlay: false, 
		slideSpeed:2000,
		items : 4,
		pagination:true,
		navigation:true,
		navigationText:["<i class='dp- dp-left-arrow'></i>","<i class='dp- dp-right-arrow'></i>"],
		rewindNav : true,
		lazyLoad : true
	});
      
});
  
})(jQuery);    